import React from 'react';
import LogoRight from '../assets/logo-sebrae-one.svg';
import Megafone from '../assets/megafone.png';
import { useQuery } from '../hooks/useQuery';
import { CircularProgress, Grid } from '@mui/material';
import { Carousel } from 'react-responsive-carousel';

export default function MuralAvisos() {
  const { listarAvisos, listarCalendarioPublico } = useQuery();
  const [avisos, setAvisos] = React.useState([]);
  const [calendarios, setCalendarios] = React.useState([]);
  const [loadingAviso, setLoadingAviso] = React.useState(true);
  const [loadingCalendario, setLoadingCalendario] = React.useState(true);

  const buscarCalendarios = async () => {
    const result = await listarCalendarioPublico();
    if (result && result.data) {
      setCalendarios(result.data.data);
    }

    setLoadingCalendario(false);
  };

  const buscarAvisos = async () => {
    const result = await listarAvisos();

    if (result && result.data) {
      setAvisos(result.data.data);
    }
    setLoadingAviso(false);
  };

  React.useEffect(() => {
    buscarAvisos();
    buscarCalendarios();
  }, []);

  return (
    <Grid
      item
      sm={8}
      style={{
        backgroundColor: '#00669e',
        height: '100vh',
        padding: 20,
        backgroundImage: `url(${require('../assets/login_background.png')})`,
        backgroundRepeat: 'no-repeat, repeat',
        backgroundSize: 'cover',
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ display: 'flex' }}>
          <img src={LogoRight} style={{ width: 200 }} />
          <h3 style={{ color: 'white', marginLeft: 20 }}>
            PORTAL DE FORNECEDORES SEBRAE MG
          </h3>
        </Grid>
        <Grid xs={8} item>
          <div
            style={{
              background: 'white',
              padding: 10,
              height: 120,
              borderRadius: 10,
            }}
          >
            <p style={{ color: '#0757C3' }}>
              Assista ao vídeo com orientação para cadastro:
              <a href="https://youtu.be/1vpVOSAolew" target="_blank">
                clique aqui para assistir
              </a>
            </p>
            <p style={{ color: '#0757C3' }}>
              Assista ao vídeo com orientação para envio de notas:
              <a href="https://youtu.be/P3lEz-C-16Y" target="_blank">
                clique aqui para assistir
              </a>
            </p>
          </div>
        </Grid>
        <Grid xs={4} item>
          <div
            style={{
              height: 101,
              flexWrap: 'wrap',
              background: '#D58300',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: 20,
              borderRadius: 10,
            }}
          >
            <p style={{ color: 'white', textAlign: 'center' }}>
              DATA LIMITE PARA EMISSÃO E ENVIO DAS NOTAS FISCAIS
            </p>

            {loadingCalendario && <CircularProgress size={24} />}

            {!loadingCalendario && (
              <Carousel
                showStatus={false}
                showIndicators={false}
                dynamicHeight={false}
                width={250}
              >
                {calendarios &&
                  calendarios.map((res) => {
                    return (
                      <div style={{ background: '#D58300' }}>
                        <h3 style={{ color: 'white' }}>
                          {res.formatted_date_month}
                        </h3>
                      </div>
                    );
                  })}
              </Carousel>
            )}
          </div>
        </Grid>
        <Grid xs={12} item>
          <div
            style={{
              background: '#0757C3',
              padding: 10,
              height: 80,
              borderRadius: 10,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img style={{ width: 190 }} src={Megafone} />
            <span style={{ color: 'white' }}>COMUNICADOS IMPORTANTES</span>
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        marginTop={5}
        className="scrollbar"
        id="style-3"
        style={{
          height: `calc(100% / 2)`,
          overflowX: 'none',
          overflowY: 'scroll',
          backgroundColor: 'transparent',
        }}
      >
        {loadingAviso && <CircularProgress size={24} />}

        {!loadingAviso && avisos && (
          <>
            {avisos.map((res) => {
              return (
                <div
                  key={`avisos-carousel-${res.id}`}
                  style={{
                    opacity: 1,
                    background: 'hsla(0, 23.8%, 95.9%, 0.3)',
                    height: 120,
                    marginLeft: 10,
                    borderRadius: 10,
                    marginBottom: 10,
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                    paddingRight: '10px',
                    paddingLeft: '10px',
                  }}
                >
                  <p
                    dangerouslySetInnerHTML={{ __html: res.texto }}
                    style={{
                      color: 'white',
                    }}
                  ></p>
                </div>
              );
            })}
          </>
        )}
      </Grid>
    </Grid>
  );
}
